// src/services/apiClient.js
import axios from 'axios';

// Environment'a göre API URL belirleme
// Development: npm start -> .env.development (localhost)
// Production: npm run build -> .env.production (api.harmonysenseai.com)
const baseURL = process.env.REACT_APP_API_URL || 'https://api.harmonysenseai.com/api';

// Debug için (development modunda)
if (process.env.NODE_ENV === 'development') {
  console.log('API URL:', baseURL);
  console.log('Environment:', process.env.REACT_APP_ENV);
}

const apiClient = axios.create({
  baseURL,
});

// Eğer token'ı her istekle otomatik göndermek istersen
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('harmonyadmintoken'); // ya da getCurrentUser()'dan bir JWT alabilirsin
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;